import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getOperationsWithdrawal = (params) => {
    return axios.get(`${backendHost}/api/admin/ggr/operations/withdrawal`, {params});
};

export {
    getOperationsWithdrawal
}